import DOMPurify from 'dompurify';

export const safeHtml = (html: string | undefined) => {
  if (!html) {
    return '';
  }

  const sanitizedHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['sup', 'span'],
    ALLOWED_ATTR: ['class'],
  });

  return sanitizedHtml;
};
